import getThemesLogic from "./getThemesLogic";
import getThemesFailureLogic from "./getThemesFailureLogic";
import createThemesLogic from "./createThemesLogic";
import createThemesSuccessLogic from "./createThemesSuccessLogic";
import createThemesFailureLogic from "./createThemesFailureLogic";
import deleteThemesLogic from "./deleteThemesLogic";
import deleteThemesSuccessLogic from "./deleteThemesSuccessLogic";
import deleteThemesFailureLogic from "./deleteThemesFailureLogic";
import selectThemeLogic from "./selectThemeLogic";
import selectThemeFailureLogic from "./selectThemeFailureLogic";
import loadDefaultThemeLogic from "./loadDefaultThemeLogic";
import loadDefaultThemeFailureLogic from "./loadDefaultThemeFailureLogic";
import editThemeLogic from "./editThemeLogic";
import editThemeSuccessLogic from "./editThemeSuccessLogic";
import editThemeFailureLogic from "./editThemeFailureLogic";

export default [
	...createThemesLogic,
	...createThemesSuccessLogic,
	...createThemesFailureLogic,
	...getThemesLogic,
	...getThemesFailureLogic,
	...deleteThemesLogic,
	...deleteThemesSuccessLogic,
	...deleteThemesFailureLogic,
	...selectThemeLogic,
	...selectThemeFailureLogic,
	...loadDefaultThemeLogic,
	...loadDefaultThemeFailureLogic,
	...editThemeLogic,
	...editThemeSuccessLogic,
	...editThemeFailureLogic,
];
